// extracted by mini-css-extract-plugin
module.exports = {"entry":"_1siMy","clickable":"_2_KKs","avatar":"AOGb4","withUnderLine":"_1c6q-","name":"_3DDIe","checkbox":"_3oUHF","badges":"_2IArf"};